import { useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import ProjectStore, { currentProjectAtom, projectRolesAtom } from '../stores/ProjectStore';
import { IProjectType, Project_Base } from '~/common/typescript/models/Project';
import LoadingStore from '~/components/common/Loading/LoadingStore';
import { API_URL_ADMIN, PORTAL_PROJECT_ID } from '~/config/config';
import { remote_getProjectById } from '~/common/typescript/apis/ProjectAPIs';
import { ACLProjectAPIs } from '~/common/typescript/apis/ACLProjectAPIs';
import { useLocation, useParams } from 'react-router-dom';
import { RoutesPrefix } from '~/routes/routes';
import { showGeocollectPanelAtom } from '~/components/Map/stores/mapStore';
import { projectMembersWithRolesAsyncAtom, projectMembersWithRolesAtom } from '~/components/Map/Member/MemberStore';

const ProjectDataController = () => {
  const [project, setProject] = useAtom<Project_Base | null>(ProjectStore);
  const [loading, setLoading] = useAtom<boolean>(LoadingStore);
  const [currentProject, setCurrentProject] = useAtom(currentProjectAtom);
  const [showGeocollectPanel, setShowGeocollectPanel] = useAtom(showGeocollectPanelAtom);
  const setProjectRoles = useSetAtom(projectRolesAtom);
  const fetchProjectMembers = useSetAtom(projectMembersWithRolesAsyncAtom);
  const setProjectMembers = useSetAtom(projectMembersWithRolesAtom);

  const location = useLocation();
  const params = useParams();

  // Load project by ID from route
  useEffect(() => {
    let pathname = location.pathname;
    if (pathname.startsWith(`${RoutesPrefix.PROJECT}`)) {
      const projectId = Number(params.projectID);
      if (projectId) {
        remote_getProjectById(projectId).then((project) => {
          setCurrentProject(project);
        });
      }
    } else {
      setCurrentProject(undefined);
      setProjectRoles([]);
    }
  }, [params.projectID, location.pathname]);

  // Load user project roles and members when project changes
  useEffect(() => {
    if (currentProject?.id) {
      ACLProjectAPIs.remote_ACLProject_getMyRoles({ projectId: currentProject.id })
        .then((roles) => {
          setProjectRoles(roles || []);
        })
        .catch((err) => {
          console.error('Failed to get project roles:', err);
          setProjectRoles([]);
        });

      fetchProjectMembers();
    } else {
      setProjectRoles([]);
      setProjectMembers([]);
    }
  }, [currentProject?.id]);

  // Auto-open geocollect panel when project type is COLLECT
  useEffect(() => {
    if (currentProject?.type === IProjectType.COLLECT) {
      setShowGeocollectPanel(true);
    }
  }, [currentProject]);

  return <></>;
};

export default ProjectDataController;
